<template>
	<div class="table-unassigned-processes">
		<div class="" v-if="unassignedProjects.length > 0">
			<div class="row">
				<div class="col-sm-6" style="float: right !important;">
					<div id="" class="">
						<label>
							<div class="input-group">
								<input id="searchCandidate" type="search" v-model="search" class="form-control" placeholder="Buscar por nombre de candidato" aria-controls="">
								<span class="input-group-addon">
									<i class="fa fa-search"></i>
								</span>
							</div>
						</label>
					</div>
				</div>
			</div>
			<table class="table" id="tableUnassignedProjects">
				<thead>
					<tr>
						<th style="width: 5% !important;">ID</th>
						<th style="width: 5% !important;">Cliente</th>
						<th style="width: 15% !important;">Fecha creación</th>
						<th style="width: 15% !important;">Aspirante</th>
						<!-- <th style="width: 9% !important;">Proceso</th> -->
						<th style="width: 9% !important;">ciudad</th>
						<th style="width: 11% !important;">Estado</th>
						<th style="width: 9% !important;">Acciones</th>
					</tr>
				</thead>
				<tbody>
					<template v-for="(project, index) in unassignedProjects">
						<tr :key="project.id">
							<td class="headAssignments">{{project.id}}</td>
							<td class="headAssignments">{{project.client | getAttribute('name')}}</td>
							<td class="headAssignments">{{project.created_at}}</td>
							<td class="headAssignments">{{project.person_full_name}}</td>
							<!-- <td class="headAssignments">{{project.project_type_name}}</td>						 -->
							<td class="headAssignments">{{project.city | getAttribute('name')}}</td>
							<td class="headAssignments">{{project.status_name}}</td>
							<td>
								<div :id="`notAssignments${index}`" v-if="project.assignment_types.length == 0">Sin asginaciones</div>
								<template v-else>
									<button :id="`showSubtable${index}`" type="button" class="btn btn-success" @click="toggleAssignments(index, true)" v-if="!show[index]">Asignaciones {{project.assignment_types.length}} <i class="fa fa-arrow-down"></i></button>
									<button :id="`hideSubtable${index}`" type="button" class="btn btn-success" @click="toggleAssignments(index, false)" v-if="show[index]">Ocultar <i class="fa fa-arrow-up"></i></button>
								</template>
							</td>
						</tr>
							<template v-if="show[index]">
								<tr class="subTable" :ref="'header'+project.id" v-if="show[index]" :key="`headAssignment${project.id}`">
									<th style="width: 5% !important; border:none !important; background: white !important;"></th>
									<th style="width: 5% !important;">ID</th>
									<th style="width: 15% !important;">Asignación</th>
									<th style="width: 15% !important;">Analista</th>
									<th style="width: 15% !important;">Asignar</th>
									<th style="width: 15% !important;">Desasignar</th>
								</tr>
								<tr class="subTable" :ref="'rows'+project.id" v-for="assignment_type in project.assignment_types" :key="`${project.id}_${assignment_type.id}`">
									<td class="noBorder"></td>
									<td>{{assignment_type.id}}</td>
									<td>{{assignment_type.name}}</td>
									<td>{{assignment_type | analystName(project.assignments) }}</td>
									<td>
										<div v-if="!haveAnalyst(assignment_type, project.assignments)">
											<button type="button" class="btn btn-primary" @click.prevent="assignItToMe(project.id, assignment_type.id, index)">Asignar</button>
										</div>
									</td>
									<td>
										<div v-if="assignedToMe(assignment_type, project.assignments) && haveAnalyst(assignment_type, project.assignments)">
											<button type="button" class="btn btn-danger" @click.prevent="deallocateItToMe(assignment_type.id, project.assignments, index)">Desasignar</button>
										</div>
									</td>
								</tr>
							</template>
					</template>
				</tbody>
			</table>
			<div class="row" v-if="paginateUnassignedProjects != null">
				<div class="col-sm-5 hidden-xs">
						<div class="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Mostrando {{unassignedProjects.length}}. Pagina {{paginateUnassignedProjects.current_page}} de {{paginateUnassignedProjects.total_pages}}</div>
				</div>
				<div class="col-sm-7 col-xs-12 clearfix">
					<div class="dataTables_paginate paging_bootstrap" id="DataTables_Table_0_paginate">
						<ul class="pagination pagination-sm remove-margin">
							<li class="prev" @click.prevent="changePage(paginateUnassignedProjects.prev_page)" v-if="paginateUnassignedProjects.prev_page > 0">
								<a href="" >
									<i class="fa fa-chevron-left"></i>
									Anterior
								</a>
							</li>
							<li :class="liActive(p)" v-for="p in range(displayLinks)" :key="p" @click.prevent="changePage(p)">
								<a>{{p}}</a>
							</li>
							<li class="next" @click.prevent="changePage(paginateUnassignedProjects.next_page)" v-if="paginateUnassignedProjects.next_page != null">
								<a href="">
									Siguiente
									<i class="fa fa-chevron-right">
									</i>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div id="progress" class="progress" v-else>
			<div class="progress-bar progress-bar-striped bg-danger" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
		</div>
	</div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'TableUnassignedProcesses',
	props: ['current_user'],
	computed: {
		...mapGetters(['unassignedProjects', 'paginateUnassignedProjects', 'assignments', 'paginateAssignments'])
	},
	methods: {
		...mapMutations(['changeUnassignedProjects', 'changePaginateUnassignedProjects', 'changeAssignments', 'changePaginateAssignments']),
		liActive(page){
			var classLi = ""
			if(page == this.paginateUnassignedProjects.current_page){
				classLi = "active"
			}
			return classLi
		},
		changePage(page){
			this.page = page
			this.changePaginateUnassignedProjects(null)
			this.displayLinks = page + 5
			this.getProjects()
		},
		range(end) {
			return new Array(end - this.paginateUnassignedProjects.current_page).fill().map((d, i) => i + this.paginateUnassignedProjects.current_page);
		},
		assignItToMe(project_id, assignment_type_id, indexProject){
			this.defaultValuesAxios()
      axios.post('/workers/assign_it_to_me/' + project_id, { assignment: {assignment_type_id: assignment_type_id, user_id: this.current_user.id}}).then(res=>{

				if(res.status == 200){
					var assignment = res.data.assignment

					if(indexProject != null){
						var project = this.unassignedProjects[indexProject]
						var assignments = project.assignments
						if(assignments.length > 0){

							var assignmentFound = false
							for (var i = 0; i < assignments.length; i++) {
								if(assignments[i].id == assignment.id){
									assignments[i] = assignment
									assignmentFound = true
								}
							}

							if(!assignmentFound){
								assignments.push(assignment)
							}

						}else{
							assignments.push(assignment)
						}
						project.assignments = assignments
						Vue.set(this.unassignedProjects, indexProject, project)
					}
					this.show[indexProject] = true
					this.getAssignments()
				}else{
					// this.showMessage('No se pudo actualizar el precio', 'alert-warning')
				}
      }, (err) => {
				// this.showMessage('No se pudo actualizar el precio', 'alert-danger')
			})
		},
		getAssignments(){
			this.defaultValuesAxios()
			this.changeAssignments([])
			axios.get('/workers.json?assign_page=' + this.page).then(res=>{
				if(res.status == 200){
					this.changeAssignments(res.data.assignments.data)
					this.changePaginateAssignments(res.data.assignments.paginate)
				}
			})
		},
		deallocateItToMe(assignment_type_id, assignments, index){
			var assignment = null
			assignments.forEach(assignmentIterator => {
				if(assignmentIterator.assignment_type_id == assignment_type_id){
					assignment = assignmentIterator
				}
			});

			if(assignment != null){
				this.defaultValuesAxios()
				axios.put('/workers/deallocate_it_to_me/' + assignment.id, {}).then(res=>{
					if(res.status == 200){
						var assignment = res.data.assignment
						var project = this.unassignedProjects[index]
						var assignments = project.assignments
						for (var i = 0; i < assignments.length; i++) {
							if(assignments[i].id == assignment.id){
								assignments[i] = assignment
							}
						}
						project.assignments = assignments
						Vue.set(this.unassignedProjects, index, project)
						this.getAssignments()
					}else{
						// this.showMessage('No se pudo actualizar el precio', 'alert-warning')
					}
				}, (err) => {
					// this.showMessage('No se pudo actualizar el precio', 'alert-danger')
				})
			}

		},
		defaultValuesAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
		},
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},
		toggleAssignments(index, action){
			Vue.set(this.show, index, action)
		},
		hideAssignments(){
			for (let index = 0; index < this.unassignedProjects.length; index++) {
				this.show[index] = false
			}
		},
		haveAnalyst(assignment_type, assignments){
			var assignment_type_id = assignment_type.id
			var haveUser = false
			assignments.forEach(assignment => {
				if(assignment.assignment_type_id == assignment_type_id){
					if(assignment.user != null){
						haveUser = assignment.user.first_name  + " " + assignment.user.first_name
					}
				}
			});
			return haveUser;
		},
		assignedToMe(assignment_type, assignments){
			var assignment_type_id = assignment_type.id
			var result = false
			assignments.forEach(assignment => {
				if(assignment.assignment_type_id == assignment_type_id){
					if(assignment.user != null){
						if (assignment.user.id == this.current_user.id){
							result = true
						}
					}
				}
			});
			return result;
		},
		getProjects(){
			this.defaultValuesAxios()
			this.changeUnassignedProjects([])
			axios.get('/workers.json?page=' + this.page).then(res=>{
				if(res.status == 200){
					this.changeUnassignedProjects(res.data.unassigned_projects.data)
					this.changePaginateUnassignedProjects(res.data.unassigned_projects.paginate)
					this.hideAssignments()
				}
			})
		},
		searchProjects(){
			if(this.search.length > 3){
				this.defaultValuesAxios()
				axios.post('/workers/search_unassigned_list.json?search=' + this.search).then(res=>{
					if(res.status == 200){
						this.changeUnassignedProjects(res.data.unassigned_projects.data)
						this.changePaginateUnassignedProjects(res.data.unassigned_projects.paginate)
						if(this.unassignedProjects.length == 0){
							this.getProjects()
						}
						this.hideAssignments()
					}
				})
			}else{
				if(this.search.length == 0){
					this.getProjects()
				}
			}
		}
	},
	data() {
		return {
			message: '',
			typeMessage: '',
			show: [],
			displayLinks: 5,
			page: 1,
			search: ''
		}
	},
	watch: {
		search: function(){
			this.searchProjects()
		}
	},
	created () {
		this.getProjects()
	},
	components: {

	},
	filters: {
		analystName: function(assignment_type, assignments) {
			var assignment_type_id = assignment_type.id
			var user = null
			assignments.forEach(assignment => {
				if(assignment.assignment_type_id == assignment_type_id){
					if(assignment.user != null){
						user = assignment.user.first_name  + " " + assignment.user.last_name
					}
				}
			});
			return user;
		},
		getAttribute: function(object, key){
			if(object != null){
				return object[key]
			}else{
				return ''
			}
		}
	}
}
</script>
<style scoped>
	.headAssignments{
		font-size: large;
	}
	tbody > tr > td.noBorder{
		border: none;
	}
	.subTable{
		background: #fcfcfc;
	}
</style>
